import { utils } from 'xlsx'

import csvReport from './csvReport'

const isUpperCase = (string) => /^[A-Z]*$/.test(string.split(' ').join(''))

const formatData = (data, from, sort, intl) => {
  const formatter = csvReport[from]

  if (formatter) {
    return formatter(data, sort ?? {}, intl)
  }

  return data.map((row) =>
    Object.entries(row).reduce((result, [key, value]) => {
      const updatedValue = Array.isArray(value) ? value.join(',') : value

      return {
        ...result,
        [isUpperCase(key)
          ? key
          : key
              .match(/([A-Z]?[^A-Z]*)/g)
              .slice(0, -1)
              .join(' ')
              .toUpperCase()]: updatedValue,
      }
    }, {}),
  )
}

const getHeaderSourceRow = (rawData, from, sort, intl) => {
  const data = formatData(rawData, from, sort, intl)

  if (data?.length) {
    return data[0]
  }

  const formatter = csvReport[from]
  if (!formatter) {
    return null
  }

  return formatter([{}], sort ?? {}, intl)[0] ?? null
}

export const buildSheet = (rawData, from, sort, intl) => {
  const data = formatData(rawData, from, sort, intl)
  const ws = utils.json_to_sheet(data, { skipHeader: false })
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
  const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'] // if more are needed add more

  // Assigned headers names in order (A1, B1, C1, ...)
  const headerSource = getHeaderSourceRow(rawData, from, sort, intl)
  if (headerSource) {
    const headerKeys = Object.keys(headerSource).map((defaultMessage) =>
      intl
        ? intl.formatMessage({ defaultMessage, id: `EXPORT.${from}.${defaultMessage.toUpperCase()}` })
        : defaultMessage,
    )

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < headerKeys.length; i++) {
      const cellRef = `${letters[i]}1`
      ws[cellRef] = { t: 's', v: headerKeys[i] }
    }

    if (!data.length || !ws['!ref']) {
      ws['!ref'] = `A1:${letters[headerKeys.length - 1]}1`
    }
  }

  return { ws, wb }
}

export const getCsvBlob = (data, from, sort, intl) => {
  const { ws } = buildSheet(data, from, sort, intl)
  const csvContent = utils.sheet_to_csv(ws)

  return new Blob([csvContent], { type: 'text/csv;charset=utf-8' })
}
